import { Box, Typography, useMediaQuery, Menu, MenuItem } from '@mui/material';
import { CustomErrorLogger } from '../../../utils/CustomErrorLogger';
import { useHasPermission } from '../../../hooks/useHasPermission';
import { UpdateRisque } from '../editRisque/updateRisque';
import { DeleteRecord } from '../../deleteRecord';
import { useTheme } from '@mui/material/styles';
import { useTranslation } from 'react-i18next';
import { useListBackNavigation } from '../../../hooks/listNavigation';
import { useState } from 'react';
import { useSelector } from 'react-redux';
import Iconify from '../../Iconify';
import axios from 'axios';
import '../../../css/roles/roleDetailsHeader.css';

const RisqueDetailsHeader = () => {

    const { t } = useTranslation();
    const { goBack, goToList } = useListBackNavigation('/dashboard/risques');
    const theme = useTheme();
    const isDesktop = useMediaQuery(theme.breakpoints.up('md'));
    const risqueDetailsData = useSelector((state) => state.RisqueDetailsData);

    const hasRisqueUpdatePermission = useHasPermission('risk_update');
    const hasRisqueDeletePermission = useHasPermission('risk_delete');

    const [updateRisqueOpen, setUpdateRisqueOpen] = useState(false);
    const [deleteRisqueOpen, setDeleteRisqueOpen] = useState(false);
    const [anchorEl, setAnchorEl] = useState(null);
    const [errMsg, setErrMsg] = useState(null);

    const openActionMenu = Boolean(anchorEl);

    const handleDeleteRisque = async () => {
        try {
            const response = await axios.delete(`risk/${risqueDetailsData.id}`);
            if (response.status === 200 || response.status === 201) {
                setDeleteRisqueOpen(false);
                goToList();
                setErrMsg('');
            }
        } catch (error) {
            setErrMsg(error.response?.data?.message || error.message || t('Une erreur est survenue lors de la suppression de la risque.'));
            console.error('Error deleting risque:', error);
            CustomErrorLogger(error, "Delete risque in RisqueDetailsHeader");
        }
    }

    const handleOpenActionMenu = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleCloseActionMenu = () => {
        setAnchorEl(null);
    };

    const handleGoBack = goBack;

    return (
        <Box className="roleDetailsHeader_mainBox">
            <Box className="roleDetailsHeader_firstPart">
                <Iconify className='roleDetailsHeader_back_icon' icon={"material-symbols:arrow-back"} onClick={handleGoBack} />
                <Typography className="roleDetailsHeader_title">{risqueDetailsData?.name}</Typography>
                {hasRisqueUpdatePermission && <Iconify className='roleDetailsHeader_edit_icon' icon={"ic:outline-edit"} onClick={() => setUpdateRisqueOpen(true)} />}
                {risqueDetailsData?.description}
            </Box>
            <Box className="roleDetailsHeader_secondPart">
                {isDesktop && hasRisqueDeletePermission &&
                    <Box className="roleDetailsHeader_action_box" onClick={() => setDeleteRisqueOpen(true)}>
                        <Iconify className='roleDetailsHeader_delete_icon' icon={"ic:outline-delete"} />
                        <Typography className="roleDetailsHeader_delete_title">{t('Supprimer')}</Typography>
                    </Box>
                }
                {!isDesktop && <Iconify
                    className='roleDetailsHeader_dots_icon'
                    icon={"vaadin:ellipsis-dots-v"}
                    id="userPageActionMenuIcom"
                    aria-controls={openActionMenu ? 'long-menu' : undefined}
                    aria-expanded={openActionMenu ? 'true' : undefined}
                    aria-haspopup="true"
                    onClick={handleOpenActionMenu}
                />}
                <Menu
                    id="usersePageActionMenu"
                    MenuListProps="usersPageActionMenuIcom"
                    open={openActionMenu}
                    anchorEl={anchorEl}
                    onClose={handleCloseActionMenu}
                    onClick={handleCloseActionMenu}
                    slotProps={{ paper: { style: { width: '30ch', backgroundColor: '#fffff' } } }}
                >
                    {!isDesktop && hasRisqueDeletePermission &&
                        <MenuItem className='roleDetailsHeader_menuItem' onClick={() => setDeleteRisqueOpen(true)}>
                            <Iconify className='roleDetailsHeader_delete_icon' icon={"ic:outline-delete"} />
                            <Typography className="roleDetailsHeader_delete_title">{t('Supprimer')}</Typography>
                        </MenuItem>
                    }
                </Menu>
            </Box>

            {updateRisqueOpen &&
                <UpdateRisque
                    updateRisqueOpen={updateRisqueOpen}
                    setUpdateRisqueOpen={setUpdateRisqueOpen}
                />
            }

            {deleteRisqueOpen &&
                <DeleteRecord
                    errMsg={errMsg}
                    setErrMsg={setErrMsg}
                    openDelete={deleteRisqueOpen}
                    setOpenDelete={setDeleteRisqueOpen}
                    handleDelete={handleDeleteRisque}
                    title="Êtes-vous sûr de vouloir supprimer cette risque ?"
                />
            }
        </Box>
    );
}

export default RisqueDetailsHeader;